// @kkeut/lib/firebase/client - Firebase Web SDK (브라우저/Edge 가능)
import { initializeApp, getApps, getApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAnalytics, isSupported, logEvent } from "firebase/analytics";

const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,

  // ▶ 사용할 Firestore 데이터베이스 ID (선택)
  firestoreDatabaseId: process.env.NEXT_PUBLIC_FIRESTORE_DATABASE_ID,
};

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

// 명명된 DB 또는 기본 DB
export const db = firebaseConfig.firestoreDatabaseId
  ? getFirestore(app, firebaseConfig.firestoreDatabaseId)
  : getFirestore(app);

export const storage = getStorage(app);

// 클라이언트에서만 analytics 초기화
const analyticsReady =
  typeof window === "undefined"
    ? Promise.resolve(null)
    : isSupported().then((yes) => (yes ? getAnalytics(app) : null)).catch(() => null);

/** 위 인스턴스로 GA4 이벤트를 보낸다(새로 초기화하지 않음). 예약 단계 이벤트(#1104)가 쓴다. */
export async function logAnalyticsEvent(name, params) {
  const analytics = await analyticsReady;
  if (analytics) logEvent(analytics, name, params);
}
